; (async () => {
  const { default: moment } = await import('moment')
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([
    import(/* webpackMode: "eager" */ './accommodation-block.scss'),
    import('../../scripts/dbs/dbs.utilities.querystring'),


  ]).then(() => {
    $('.widget.accommodation-block').each(function (i, el) {
      $(el).data('widget', new AccommodationBlock(el, Swiper, moment))
      $(el).data('widget').init()
    })
  })

  // NOTE: Handle click and touch events on available and unavailable swipers to manually trigger hide on date range pickers if it is open.
  // This is a workaround as Swiper is intercepting events like mousedown or touchstart, preventing the date range picker from closing.
  // See https://discoveryparks.atlassian.net/browse/HPR-304
  // See https://discoveryparks.atlassian.net/browse/HPR-307
  $('.js-available-swiper, .js-unavailable-swiper').on('click touchstart', function (e) {
    const $calendar = $('.daterangepicker')
    const isInsideCalendar = $calendar.is(e.target) || $calendar.has(e.target).length > 0
    const $targetTrigger = $(e.target).closest('.calendar-trigger, .date-selector')

    // Close all other open pickers
    $('.calendar-trigger, .filters .date-selector')
      .not($(this))
      .each(function () {
        const picker = $(this).data('daterangepicker')
        if (picker && picker.isShowing) {
          picker.hide()
        }
      })

    // Close the picker if clicked outside of it
    if (!isInsideCalendar && !$targetTrigger.length) {
      $('.calendar-trigger, .filters .date-selector').each(function () {
        const picker = $(this).data('daterangepicker')
        if (picker && picker.isShowing) {
          picker.hide()
        }
      })
    }
  })
})()

function AccommodationBlock(el, Swiper, moment) {
  const self = this
  self.el = $(el)
  self.qs = new dbs.utilities.querystring()
  self.propertyCode = self.el.find('.widget.hero-banner-resort-block')?.attr('data-propertyCode')
  if (!self.propertyCode) {
    self.propertyCode = self.qs.getParameter('propertyCode');
  }

  self.today = new Date()
  self.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  self.dayAfterTomorrow = new Date(new Date().setDate(new Date().getDate() + 2))
  self.maxDate = new moment().add(1, 'y').toDate()

  self.availableCardTemplate = require('./accommodation-card-available.hbs')
  self.availableCardSingleTemplate = require('./accommodation-card-available-single.hbs')
  self.unavailableCardTemplate = require('./accommodation-card-unavailable.hbs')
  self.messageInfoTemplate = require('./message-info-template.hbs')

  self.isMobile = $('body').hasClass('is-mobile-view')
  const resultsWrapper = self.el

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('AccommodationBlock init', self)
    }
    self.el.css('opacity', 1)

    // TODO
    // Listen for event to receieve data for rendering available and unavailable cards
    // Render cards dynamically based on the data received
    // Init tooltips for pills on cards
    // Init 'view availablity' calendar for each card
    // Init image sliders for each card

    // After we render the cards, we need to initialize the swiper
    window.dbs.globalEvents.subscribe('RenderProperties', function (payload) {
      if (process.env.NODE_ENV === 'development') {
        console.log('RenderProperties', payload)
      }
      renderAvailableProperties(payload.data, payload.focusRoomCode)
      renderNotAvailableProperties(payload.data, payload.focusRoomCode)
      hanldleAvailabilityCalendars(payload.data, payload.filters)
      handleTooltipsAndIcons(payload.data)
    })
  }

  function hanldleAvailabilityCalendars(data, filters) {
    // Init date range picker for each 'available' property
    const availablePropertiesDatesAndPrices = data.AvailableProperties.reduce(
      (acc, property) => {
        // Create two separate arrays for available date, and available date price where their index matches.
        // So, the price matching for date `availableDates[42]` will be `availableDatesPrices[42]`.
        let availableDates = []
        let prices = []

        property.Dates.map((entry) => {
          if (entry.Price >= 1) {
            availableDates.push(entry.Date.substring(0, 10)) // Format dates to 'YYYY-MM-DD'
            prices.push(entry.Price)
          }
        })

        // Assign each array to the key of the same 'room code'
        acc['availableDates'][property.RoomCode] = availableDates
        acc['prices'][property.RoomCode] = prices

        return acc
      },
      {
        availableDates: {},
        prices: {},
      },
    )


    self.el.find('.js-available-swiper .calendar-trigger').each(function (i, el) {
      const calendarTrigger = $(el)
      const resultItem = calendarTrigger.parents('.accommodation-card')
      const roomCode = resultItem.data('roomcode')

      initPropertyCalendar(
        {
          datesData: availablePropertiesDatesAndPrices,
          triggerEl: calendarTrigger,
          parentEl: resultItem,
          roomCode: roomCode,
        },
        filters,
      )
    })

    // Init date range picker for each 'not available' property
    const notAvailablePropertiesDatesAndPrices = data.NotAvailableProperties.reduce(
      (acc, property) => {
        // Create two separate arrays for available date, and available date price where their index matches.
        // So, the price matching for date `availableDates[42]` will be `availableDatesPrices[42]`.
        let availableDates = []
        let prices = []

        property.Dates.map((entry) => {
          if (entry.Price >= 1) {
            availableDates.push(entry.Date.substring(0, 10)) // Format dates to 'YYYY-MM-DD'
            prices.push(entry.Price)
          }
        })

        // Assign each array to the key of the same 'room code'
        acc['availableDates'][property.RoomCode] = availableDates
        acc['prices'][property.RoomCode] = prices

        return acc
      },
      {
        availableDates: {},
        prices: {},
      },
    )


    self.el.find('.js-unavailable-swiper .calendar-trigger').click(async function (event) {
      const calendarTrigger = $(event.currentTarget)
      const resultItem = calendarTrigger.parents('.accommodation-card')
      const roomCode = resultItem.data('roomcode')

      // Get data by 'roomCode' of item
      // TODO fix recursive call if 'roomCode' fails to match after ajax call (if no data, if endpoint fails)
      if (notAvailablePropertiesDatesAndPrices['availableDates'][roomCode].length == 0) {
        event.preventDefault()

        // TODO move loading from whole widget to just the result item or result item calendar trigger?
        self.el.addClass('loading')

        const data = await self.getPropertiesDataByRoomCode(roomCode, filters)
        if (process.env.NODE_ENV === 'development') {
          console.log('getPropertiesDataByRoomCode', data)
        }
        data.AvailableProperties.reduce((acc, property) => {
          // Create two separate arrays for available date, and available date price where their index matches.
          // So, the price matching for date `availableDates[42]` will be `availableDatesPrices[42]`.
          let availableDates = []
          let prices = []

          property.Dates.map((entry) => {
            availableDates.push(entry.Date.substring(0, 10)) // Format dates to 'YYYY-MM-DD'
            prices.push(entry.Price)
          })

          // Assign each array to the key of the same 'room code'
          acc['availableDates'][property.RoomCode] = availableDates
          acc['prices'][property.RoomCode] = prices

          return acc
        }, notAvailablePropertiesDatesAndPrices);

        self.el.removeClass('loading')
      }

      if (!calendarTrigger.data('daterangepicker')) {
        event.preventDefault()

        initPropertyCalendar(
          {
            datesData: notAvailablePropertiesDatesAndPrices,
            triggerEl: calendarTrigger,
            parentEl: resultItem,
            roomCode: roomCode,
          },
          filters,
        )

        calendarTrigger.click()
      }
    })
  }

  self.getPropertiesDataByRoomCode = (roomCode, filters) => {
    if (!roomCode) return

    let propertyCode = self.qs.getParameter('propertyCode');
    const data = {
      roomCodes: [roomCode],
      propertyCode: propertyCode,
      arrive: filters.arrive,
      depart: filters.depart,
      adults: filters.adults,
      kids: filters.kids,
      infants: filters.infants,
      accommodationType: filters.accommodationType,
    }

    return $.ajax({
      url: $(el).attr('data-search-top-park-room'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
  }

  function handleTooltipsAndIcons(data) {
    // Handle tooltips
    if ($(window).width() > 1024) {
      self.el.find('.pill.tooltip').popup({
        on: 'hover',
        position: 'top left',
        inline: true, // required to position the tooltip correctly
      })
    }

    // Set images, icons and tooltip text in result items
    self.fireIcon = data.FireRestrictedIcon
    self.petIcon = data.PetRestrictedIcon
    self.fireIconText = data.FireRestrictedIconText
    self.petIconText = data.PetRestrictedIconText
    self.rewardLogo = data.RewardLogo
    self.el.find('.fire-icon').attr('src', self.fireIcon)
    self.el.find('.fire-icon').parents('.icon').attr('data-tooltip', self.fireIconText)
    self.el.find('.pet-icon').attr('src', self.petIcon)
    self.el.find('.pet-icon').parents('.icon').attr('data-tooltip', self.petIconText)
    self.el.find('.reward-logo img').attr('src', self.rewardLogo)
  }

  /**
   * Checks to see if the element bottom falls out of view, and scrolls into view if true. Determines what layout
   * is displaying (stacked, or two column) using `matchMedia` then compares the element bottom against the
   * relevant parent scrolling element bottom (window or results wrapper) and scrolling to ensure the element is
   * fully in view.
   * @param el - jQuery DOM element
   */
  function scrollElBottomIntoView(el) {
    const elBottom = el[0].getBoundingClientRect().bottom

    // If two column layout, else stacked layout
    const mediaQuery = window.matchMedia('(min-width: 768px)')
    if (mediaQuery.matches) {
      const overflowDistance = elBottom - resultsWrapper[0].getBoundingClientRect().bottom
      if (overflowDistance > 0) {
        resultsWrapper[0].scrollBy({
          top: overflowDistance,
          behavior: 'smooth',
        })
      }
    } else {
      const overflowDistance = elBottom - window.innerHeight
      if (overflowDistance > 0) {
        window.scrollBy({
          top: overflowDistance,
          behavior: 'smooth',
        })
      }
    }
  }

  function initPropertyCalendar({ triggerEl, parentEl, roomCode, datesData }, filters) {
    let availableDates = datesData.availableDates[roomCode]

    triggerEl.daterangepicker(
      {
        autoApply: true,
        opens: 'center',
        drops: 'up',
        startDate: moment(filters.arrive, 'YYYY-MM-DD'),
        endDate: moment(filters.depart, 'YYYY-MM-DD'),
        minDate: self.today,
        maxDate: self.maxDate,
        // parentEl: parentEl, // NOTE: parentEl has overflow hidden, so will clip the calendar. Do not set this.
        locale: {
          format: 'YYYY-MM-DD',
        },
        isInvalidDate: function (date) {
          // If no available dates, return true to disable all dates
          if (!availableDates || !availableDates.length) {
            return true
          }
          // Check if the date is not in the available dates array
          return !availableDates.includes(moment(date).format('YYYY-MM-DD'))
        },
        isCustomDate: function (date) {
          let theDate = moment(date).format('YYYY-MM-DD')
          let availableDateIndex = availableDates?.indexOf(theDate)

          // If the date is not available, return 'not-available' class
          if (!availableDateIndex || availableDateIndex === -1) {
            return ['not-available']
          }

          let availableDatePrice = datesData.prices[roomCode][availableDateIndex]
          return ['calendar-price-tooltip', `price_${availableDatePrice}`]
        },
      },
      function (startDate, endDate) {
        window.dbs.globalEvents.emit(
          'update_selected_dates',
          {
            dataFrom: startDate,
            dataTo: endDate,
            roomCode: roomCode,
          },
          true,
        )
      },
    )

    // Add event listeners for show/hide events
    triggerEl.on('show.daterangepicker hide.daterangepicker', function (event, picker) {
      // console.log('show.daterangepicker hide.daterangepicker', event, picker)
      if (event.type === 'show') {
        picker.element.addClass('open')
        scrollElBottomIntoView(picker.container)
      } else {
        picker.element.removeClass('open')
      }
    })
  }

  function showAvailableProperties() {
    self.el.find('.js-available-container').removeClass('hidden')
  }
  function hideAvailableProperties() {
    self.el.find('.js-available-container').addClass('hidden')
  }
  function showNotAvailableProperties() {
    self.el.find('.js-unavailable-container').removeClass('hidden')
  }
  function hideNotAvailableProperties() {
    self.el.find('.js-unavailable-container').addClass('hidden')
  }

  function renderAvailableProperties(data, focusRoomCode) {
    // Update 'available' summary text
    // self.el.find('.available .summary').html(data.Summary)

    // If we have a 'message' we do not have any 'available' properties to show
    // thus we will update the UI to show 'nearby parks' in place.
    AccommodationAvailabilityMessageHandler.handleMessage(data, self)

    const availablePropertiesCount = data.AvailableProperties.length

    // Hide 'available' properties if none
    if (!availablePropertiesCount) {
      hideAvailableProperties()
    } else {
      showAvailableProperties()
    }

    var dealcodevariable = checkDealCode()

    const availableResultsContainer = self.el.find('.js-available-swiper > .swiper-wrapper')
    const pageParams = window.location.href.split('?')[1]

    // Render the 'available' properties list items
    const availablePropertiesFragment = new DocumentFragment()
    for (let i = 0; i < availablePropertiesCount; i++) {
      const property = data.AvailableProperties[i]

      // Clean up numbers
      // NOTE: Show decimals as needed => property.Example = foo.Price && (Number.isInteger(foo.Price) ? foo.Price : Number(foo.Price).toFixed(2))
      property.TotalPrice = Math.ceil(Number(property.TotalPrice))
      property.DealPrice = property.DealPrice && Math.ceil(Number(property.DealPrice))
      property.MembersPrice = property.MembersPrice && Math.ceil(Number(property.MembersPrice))
      property.Discount = property.TotalPrice - property.DealPrice
      property.AccommodationFromPrice = Math.ceil(property.AccommodationFromPrice)
      if (property.DealApplied) {
        property.HasMessage = true;
        property.Message = "Deal Applied";
      }
      property.GdayFlutterEnabled = true;
      let actionButtons = []
      property.ActionButtons.forEach((button) => {
        // AVAILABLE
        if (button.Label == 'Enquire') {
          button.isEnquire = true
        } else {
          button.isEnquire = false
        }


        actionButtons.push(button)
      })
      property.ActionButtons = actionButtons

      const indexParam = `index=${i + 1}`
      // Append params
      // CW-8299 Assign index (starting from 1) to each items' links, to know position of item in results list, when data pushed to GA.
      property.Index = i + 1
      for (let j = 0; j < property.ActionButtons.length; j++) {
        const button = property.ActionButtons[j]
        if (button.Label === "Book Now") {
          // Change it from the accom to the park, and append the preview panel opener
          var parkUrl = button.Path.replace(/\/[^/?]+(?=\?|$)/, '')
          button.Path = `${parkUrl}${window.location.search}&${indexParam}&accommodationRoomId=${property.RoomCode}&openPreviewWindow=true`
        }
      }

      //Particular deal accommodation filters via pulling in room code and checking it against the data attributes under data-particular-id-list
      if (dealcodevariable != null && dealcodevariable != '') {
        var element = document.querySelector(`[data-promocode="${dealcodevariable}"]`)

        if (element) {
          const particularIdList = element.getAttribute('data-particular-id-list')
          const idArray = particularIdList.split(',').map((item) => item.trim())
          const isMatchFound = idArray.some((id) => id === property.RoomCode)
          if (isMatchFound) {
            property.DealApplied = true
          }
        }
      }
      // Render HTML
      const template = document.createElement('template')
      // availableCardTemplate
      // availableCardSingleTemplate
      if (availablePropertiesCount === 1) {
        template.innerHTML = self.availableCardSingleTemplate(property)
      } else {
        template.innerHTML = self.availableCardTemplate(property)
      }

      availablePropertiesFragment.append(template.content)
    }
    availableResultsContainer.empty()
    availableResultsContainer.append(availablePropertiesFragment)
    self.initAvailableSwiper(focusRoomCode)

    // Init image slider for each result item
    availableResultsContainer.find('.card-images-slider').each(function (i, el) {
      const swiperEl = $(el)
      // Find all slides in the swiper
      const slides = swiperEl.find('.swiper-slide')
      if (slides.length < 2) {
        return
      }
      // Show the navigation buttons
      const nextEl = swiperEl.find('.swiper-button-next')
      const prevEl = swiperEl.find('.swiper-button-prev')
      nextEl.removeClass('!hidden')
      prevEl.removeClass('!hidden')
      //  Initialize the swiper
      new Swiper(swiperEl, {
        loop: false,
        autoHeight: false,
        watchOverflow: true,
        allowTouchMove: false, // disable touch swiping for nested swipers
        slidesPerView: 'auto',
        navigation: {
          nextEl: swiperEl.find('.swiper-button-next'),
          prevEl: swiperEl.find('.swiper-button-prev'),
        },
        pagination: {
          el: swiperEl.find('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      })
    })
  }

  function renderNotAvailableProperties(data) {
    // Hide 'not available' properties if less than 2
    if (data.NotAvailableProperties.length < 2) {
      hideNotAvailableProperties()
    } else {
      showNotAvailableProperties()
    }

    let currentIndex = data.AvailableProperties.length + 1

    const unavailableResultsContainer = self.el.find('.js-unavailable-swiper > .swiper-wrapper')
    //const pageParams = window.location.href.split('?')[1]
    const pageParamsList = new URLSearchParams(window.location.href.split('?')[1])
    pageParamsList.delete('index')
    const pageParams = pageParamsList.toString()

    // Render the 'not available' properties list items
    const notAvailablePropertiesFragment = new DocumentFragment()
    for (let i = 0; i < data.NotAvailableProperties.length; i++) {
      const property = data.NotAvailableProperties[i]

      // Clean up numbers
      // NOTE: Show decimals as needed => property.Example = foo.Price && (Number.isInteger(foo.Price) ? foo.Price : Number(foo.Price).toFixed(2))
      property.TotalPrice = Math.ceil(Number(property.TotalPrice))
      property.DealPrice = property.DealPrice && Math.ceil(Number(property.DealPrice))
      property.MembersPrice = property.MembersPrice && Math.ceil(Number(property.MembersPrice))
      property.Discount = property.TotalPrice - property.DealPrice
      property.AccommodationFromPrice = Math.ceil(property.AccommodationFromPrice)
      property.Index = currentIndex
      property.RoomUrl = `${property.RoomUrl}?${pageParams}&index=${property.Index}`
      property.GdayFlutterEnabled = window.FlutterParityEnabled

      let actionButtons = []
      property.ActionButtons.forEach((button) => {
        if (button.Label.trim() == 'Enquire') {
          button.isEnquire = true
        } else {
          button.isEnquire = false
        }
        button.Path = `${button.Path}?${pageParams}&index=${currentIndex}`
        actionButtons.push(button)
      })

      currentIndex += 1
      property.ActionButtons = actionButtons
      // var dealcodevariable = checkDealCode();

      // Render HTML
      const template = document.createElement('template')
      template.innerHTML = self.unavailableCardTemplate(property)
      notAvailablePropertiesFragment.append(template.content)
    }
    unavailableResultsContainer.empty()
    unavailableResultsContainer.append(notAvailablePropertiesFragment)
    self.initNotAvailableSwiper()

    // Init image slider for each result item
    unavailableResultsContainer.find('.card-images-slider').each(function (i, el) {
      const swiperEl = $(el)
      // Find all slides in the swiper
      const slides = swiperEl.find('.swiper-slide')
      if (slides.length < 2) {
        return
      }
      // Show the navigation buttons
      const nextEl = swiperEl.find('.swiper-button-next')
      const prevEl = swiperEl.find('.swiper-button-prev')
      nextEl.removeClass('!hidden')
      prevEl.removeClass('!hidden')
      //  Initialize the swiper
      new Swiper(swiperEl, {
        loop: false,
        autoHeight: false,
        watchOverflow: true,
        allowTouchMove: false, // disable touch swiping for nested swipers
        slidesPerView: 'auto',
        navigation: {
          nextEl: swiperEl.find('.swiper-button-next'),
          prevEl: swiperEl.find('.swiper-button-prev'),
        },
        pagination: {
          el: swiperEl.find('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      })
    })
  }

  self.initAvailableSwiper = function (focusRoomCode) {
    if (!self.aSwiperEl) {
      self.aSwiperEl = self.el.find('.js-available-swiper')
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('self.aSwiperEl', self.aSwiperEl)
    }

    // Find all slides in the swiper
    const slides = self.aSwiperEl.find('> .swiper-wrapper > .swiper-slide')
    self.aSwiperEl.attr('data-slides-count', slides.length)

    // Buttons are not within the self.aSwiperEl, but within the parent element
    const nextEl = self.aSwiperEl.parent().find('.swiper-button-next.accommodation-block-swiper-button')
    const prevEl = self.aSwiperEl.parent().find('.swiper-button-prev.accommodation-block-swiper-button')
    // Only setup navigation if there are enough slides
    if (slides.length > 3) {
      nextEl.removeClass('!hidden')
      prevEl.removeClass('!hidden')
    } else {
      nextEl.addClass('!hidden')
      prevEl.addClass('!hidden')
    }

    if (self.aSwiper) {
      self.aSwiper.update()
      self.aSwiper.slideTo(0)
    } else {
      self.aSwiper = new Swiper(self.aSwiperEl, {
        loop: false,
        autoHeight: false,
        watchOverflow: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: self.aSwiperEl.find('> .swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      })
    }

    // If focusRoomCode is provided, slide to the specific room code
    if (focusRoomCode) {
      let targetIndex = null
      // For each slide
      slides.each(function (i, el) {
        // Get the room code from the data attribute
        const roomCode = $(this).find('.accommodation-card').first().attr('data-roomcode')
        // CHeck if the room code matches the focusRoomCode
        if (roomCode === focusRoomCode) {
          targetIndex = i
          return false // break loop
        }
      })
      // If targetIndex is found, slide to it
      if (targetIndex !== null) {
        self.aSwiper.slideTo(targetIndex)
      }
    }

    // Hide date range picker when swiping
    // NOTE: The daterangepicker does not hide on drag swipe, so we need to handle it manually
    self.aSwiper.on('sliderMove', function () {
      $('.calendar-trigger').each(function () {
        const picker = $(this).data('daterangepicker')
        if (picker && picker.isShowing) {
          picker.hide() // Properly hides and updates internal state
        }
      })
    })
  }

  self.initNotAvailableSwiper = function (focusRoomCode) {
    self.nSwiperEl = self.el.find('.js-unavailable-swiper')

    // Find all slides in the swiper
    const slides = self.nSwiperEl.find('> .swiper-wrapper > .swiper-slide')
    self.nSwiperEl.attr('data-slides-count', slides.length)
    // Buttons are not within the self.nSwiperEl, but within the parent element
    const nextEl = self.nSwiperEl.parent().find('.swiper-button-next.accommodation-block-swiper-button')
    const prevEl = self.nSwiperEl.parent().find('.swiper-button-prev.accommodation-block-swiper-button')
    // Only setup navigation if there are enough slides
    if (slides.length > 4) {
      nextEl.removeClass('!hidden')
      prevEl.removeClass('!hidden')
    } else {
      nextEl.addClass('!hidden')
      prevEl.addClass('!hidden')
    }

    if (self.nSwiper) {
      self.nSwiper.update()
      self.nSwiper.slideTo(0)
    } else {
      self.nSwiper = new Swiper(self.nSwiperEl, {
        loop: false,
        autoHeight: false,
        watchOverflow: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: self.nSwiperEl.find('> .swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      })
    }

    // If focusRoomCode is provided, slide to the specific room code
    if (focusRoomCode) {
      let targetIndex = null
      // For each slide
      slides.each(function (i, el) {
        // Get the room code from the data attribute
        const roomCode = $(this).find('.accommodation-card').first().attr('data-roomcode')
        // CHeck if the room code matches the focusRoomCode
        if (roomCode === focusRoomCode) {
          targetIndex = i
          return false // break loop
        }
      })
      // If targetIndex is found, slide to it
      if (targetIndex !== null) {
        self.nSwiper.slideTo(targetIndex)
      }
    }

    // Hide date range picker when swiping
    // NOTE: The daterangepicker does not hide on drag swipe, so we need to handle it manually
    self.nSwiperEl.on('sliderMove', function () {
      $('.calendar-trigger').each(function () {
        const picker = $(this).data('daterangepicker')
        if (picker && picker.isShowing) {
          picker.hide() // Properly hides and updates internal state
        }
      })
    })
  }

  function checkDealCode() {
    // Use the current page's URL
    const url = window.location.href
    // Create a URL object
    const urlObj = new URL(url)
    // Extract the 'dealCode' value
    const dealCode = urlObj.searchParams.get('dealCode')
    // Log or use the dealCode value as needed
    if (process.env.NODE_ENV === 'development') {
      console.log('the deal code is as follows: ', dealCode) // Output: the dealCode value from the current URL
    }
    return dealCode
  }
}

const parksUnavailability =
  'We could not find availability at your preferred park based on your search. Please modify your search and try again or you could consider these parks that are nearby.'
const ExceededBookingCutOffTime = 'ExceededBookingCutOffTime'
const BelowMinimunLengthOfStay = 'BelowMinimunLengthOfStay'

var AccommodationAvailabilityMessageHandler = {
  handleMessage: function (data, self) {
    if (process.env.NODE_ENV === 'development') {
      console.log('AccommodationAvailabilityMessageHandler.handleMessage', data, self)
    }

    // Clear previous messages text
    self.el.find('#accommodation-availability-message').remove()

    if (data.Message && data.Message.length) {
      //hacky fix to allow for unique message handling. The api wasn't producing an error identifier
      if (
        data.Message == parksUnavailability ||
        data.UnavailableReasonType === ExceededBookingCutOffTime ||
        data.UnavailableReasonType === BelowMinimunLengthOfStay
      ) {
        AccommodationAvailabilityMessageHandler.showNearByParks(self)
      }
      // Show the message text
      const template = document.createElement('template')
      template.innerHTML = self.messageInfoTemplate({
        id: 'accommodation-availability-message',
        messageBody: data.Message,
      })
      self.el.find('.message-container').append(template.content)
    } else {
      AccommodationAvailabilityMessageHandler.showAvailableParks(self)
    }
  },
  showAvailableParks: function (self) {
    self.el.find('.availability-line .available').show()
    self.el.find('.availability-line .nearby-parks').hide()
  },
  showNearByParks: function (self) {
    self.el.find('.availability-line .available').hide()
    self.el.find('.availability-line .nearby-parks').show()
  },
}
